import styled from "styled-components";
import { Link } from "react-router-dom";

export const OurSchoolContainer = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 60px auto 60px;
  padding: 0 var(--container-pad);

  @media (max-width: 600px) {
    margin: 32px auto 40px;
  }
`;

export const HeroBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 14px;
  margin-bottom: 48px;
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  background: var(--color-primary-soft);
  color: var(--color-primary);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  border-radius: 999px;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: clamp(28px, 4vw, 44px);
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.5px;
  color: var(--color-text);
  max-width: 900px;
`;

export const Accent = styled.div`
  width: 56px;
  height: 4px;
  background: var(--color-primary);
  border-radius: 999px;
`;

export const Subtitle = styled.p`
  margin: 8px 0 0;
  max-width: 720px;
  font-size: 17px;
  line-height: 1.65;
  color: var(--color-text-muted);
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 18px;
  }
`;

export const Card = styled(Link)`
  display: flex;
  flex-direction: column;
  background: white;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  overflow: hidden;
  text-decoration: none;
  box-shadow: var(--shadow-sm);
  transition: var(--transition);

  &:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow-lg);
    border-color: var(--color-primary-light);
  }
`;

export const CardImageWrap = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
`;

export const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 320ms ease;

  ${Card}:hover & {
    transform: scale(1.05);
  }
`;

export const CardOverlay = styled.div`
  position: absolute;
  inset: auto 0 0 0;
  height: 50%;
  background: linear-gradient(to top, rgba(26, 31, 21, 0.45), transparent);
  pointer-events: none;
`;

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 22px 22px 24px;
  flex: 1;
`;

export const CardTitle = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  color: var(--color-text);
  letter-spacing: -0.2px;
  line-height: 1.3;
`;

export const CardSnippet = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: var(--color-text-muted);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const CardCTA = styled.span`
  margin-top: 8px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 700;
  color: var(--color-primary);
  letter-spacing: 0.3px;

  svg {
    width: 14px;
    height: 10px;
    transition: transform var(--transition);
  }

  ${Card}:hover & svg {
    transform: translateX(4px);
  }
`;
